import React, { Component } from 'react';
import {Input} from 'reactstrap';



class Training extends Component {


    constructor(props) {
        super(props);
        this.state = {
            type: "",
            video_link: "",
            document_link: "",
            description: "",
            sales_app: false,
            setter_app: false,
            active: true,
            training_items: [],
            folder: '',
            new_folder: '',
            new_name: '',
            new_link: '',
            new_sales_app: false,
            new_setter_app: false
        };



        this.titleChange = this.titleChange.bind(this);
        this.documentChange = this.documentChange.bind(this);
        this.setterCheck = this.setterCheck.bind(this);
        this.salesCheck = this.salesCheck.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.getTrainingFeed();
    }

    titleChange(event){
        this.setState({
            video_link: event.target.value
        });
    }

    documentChange(event){
        this.setState({
            document_link: event.target.value
        });
    }

    descriptionChange = (event) => {
        this.setState({
            description: event.target.value
        });
    
    };

    changeFolder = (event) => {
        this.setState({
            folder: event.target.value
        });
    };

    setterCheck(event){

        let trigger = event.target.value;
        if (this.state.setter_app === true){
            trigger = false;
        } else if (this.state.setter_app === false){
            trigger = true;
        }

        this.setState({
            setter_app: trigger
        });

    }

    salesCheck(event){


        let trigger = event.target.value;
        if (this.state.sales_app === true){
            trigger = false;
        } else if (this.state.sales_app === false){
            trigger = true;
        }


        this.setState({
            sales_app: trigger
        });


    }



    getTrainingFeed = () => {

        fetch('https://api.iondeveloper.com/admin/training/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "getAllTraining",
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            this.setState({
                training_items: data.data
            });

        }.bind(this));


    };

    removeTraining = (event) => {

        console.log(event);

        fetch('https://api.iondeveloper.com/admin/training/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "removeTrainingItem",
                    "training_id": event
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

        }.bind(this));


    };

    handleChange(event) {

        const target = event.target;
        const name = target.name;



        console.log(target.value);
        if (target.name == "new_setter_app"){
            if (this.state.new_setter_app == false){
                this.setState({
                    "new_setter_app": true
                })
                console.log("what");
            }
            if (this.state.new_setter_app == true){
                this.setState({
                    "new_setter_app": false
                })
                console.log("what");
            }
        } else if (target.name == "new_sales_app") {
            if (this.state.new_setter_app == false){
                this.setState({
                    "new_sales_app": true
                })
                console.log("what");
            }
            if (this.state.new_setter_app == true){
                this.setState({
                    "new_sales_app": false
                })
                console.log("what");
            }
        } else {
            this.setState({
                [name]:target.value
            });
        }

        console.log(this.state);
    }

    handleSubmit(event){

        event.preventDefault();

        console.log(this.state);
        fetch('https://api.iondeveloper.com/admin/training/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"addTrainingItem",
                    "document_link": this.state.new_link,
                    "folder": this.state.new_folder,
                    "description": this.state.new_name,
                    "sales_app": this.state.new_sales_app,
                    "setter_app": this.state.new_setter_app,
                    "type":"video",
                    "active":"1"
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            console.log(data);

        }.bind(this));

    }



    render() {


        let trainingItems = [];
        for (let i = 0; i < this.state.training_items.length; i++)
        {
            trainingItems.push(
                <div key={i}>
                    <div className="trainingSpan">
                        <div>
                            <b>Folder:</b> {this.state.training_items[i]['folder']}
                        </div>
                        <div>
                            <b>Description:</b> {this.state.training_items[i]['description']}
                        </div>
                    </div>
                </div>
            );
        }

        return(
            <div>
                <div className="email-container">
                    <div>
                        <h5>Add Training Item</h5>  
                    </div>
                    <div>
                        <p>
                        <a target="_blank" href="https://app.iondeveloper.com/admin-file-upload/?key=8e2e4875-20f1-4295-8664-2e4a7d75dd20">
                        <button class="upload-file-button">Upload File</button>
                        </a>
                        </p>
                    </div>
                    <form onSubmit={this.handleSubmit}>
                    <input className="standard-input" type="text" name="new_folder" value={this.state.new_folder} onChange={this.handleChange} placeholder="Folder (exact spelling to group)" />
                    <input className="standard-input" type="text" name="new_name" value={this.state.new_name} onChange={this.handleChange} placeholder="Name" />
                    <input className="standard-input" type="text" name="new_link" value={this.state.new_link} onChange={this.handleChange} placeholder="Link" />
                    Sales App <input className="standard-input" type="checkbox" name="new_sales_app" value={this.state.new_sales_app} onChange={this.handleChange} placeholder="Sales App" /> 
                    Setter App <input className="standard-input" type="checkbox" checked={this.state.new_setter_app} name="new_setter_app" value={this.state.new_setter_app} onChange={this.handleChange} placeholder="Setter App" /> 
                    <br/>
                    <button type="submit" className="form-submit" onClick={this.handleSubmit} >Create</button>
                    </form>
                </div>
                {/* {trainingItems} */}
            </div>
        );



    }



}


export default Training;


// WEBPACK FOOTER //
// ./src/components/shared/Training.js